import {Video} from './video';
import {TitleImage} from './title-image';
import {Episode} from './episode';
import {Season} from './season';
import {Review} from './review';
import {Genre} from '@app/titles/models/genre';
import {Keyword} from '@app/titles/models/keyword';
import {ProductionCountry} from '@app/titles/models/production-country';
import {Person} from '@app/titles/models/person';
import {Lien} from '@app/titles/models/lien';
import {DateValue} from '@internationalized/date';
import {VotableModel} from '@common/votes/votable-model';

export interface EpisodeCredit extends Episode {
  pivot: TitleCreditPivot;
}

export interface TitleCredit extends Person {
  pivot: TitleCreditPivot;
}

export interface PersonCredit extends Title {
  credited_episode_count?: number;
  episodes: EpisodeCredit[];
  pivot: TitleCreditPivot;
}

export interface Category {
  id: number;
  name: string;
  slug: string;
  parentid: number;
  created_at: Date;
  updated_at: Date;
}

export interface TitleCreditPivot {
  id: number;
  job: string;
  department:
    | 'directing'
    | 'writing'
    | 'actors'
    | 'creators'
    | 'publishing'
    | 'sound';
  character: string;
}

export const TITLE_MODEL = 'title';
export const MOVIE_MODEL = 'movie';
export const SERIES_MODEL = 'series';
export const GAMES_MODEL = 'games';
export const APP_MODEL = 'app';
export const MUSIC_MODEL = 'music';
export const ANIMES_MODEL = 'animes';
export const DOCS_MODEL = 'doc';
export const OTHERS_MODEL = 'other';
export const EBOOKS_MODEL = 'ebook';
export const GPS_MODEL = 'gps';
export const EMULATION_MODEL = 'emulation';

export interface Title {
  user_id: number | undefined;
  last_episode: {episode: number};
  votes: VotableModel;
  liens_active_count: number;
  torrents_active_count: number;
  nzbs_active_count: number;
  active: number;
  liens_count: number;
  torrents_count: number;
  nzbs_count: number;
  liens_by_pending_user_count: number;
  liens_by_active_user_count: number;
  liens_by_user_morts_count: number;
  liens_by_user_count: number;
  nzbs_by_user_count: number;
  torrent_by_user_count: number;
  linkadded_at: DateValue | Date | undefined;
  last_link: {
    nzb: number;
    episode_id: number;
    saison: number;
    episode: number;
    qualite: number;
  };
  categorie: any;
  category: string;
  groupedInfos: any;
  infos: any;
  imdb_id: string;
  tmdb_id: number;
  post_id: number;
  igdb_id: number;
  isbndb_id: number;
  have_link: boolean;
  have_streaming: boolean;
  id: number;
  title_id: number;
  name: string;
  original_title: string;
  type: string;
  model_type: typeof TITLE_MODEL;
  is_series: boolean;
  status: 'released' | 'upcoming' | 'ongoing' | 'ended';
  description: string;
  tagline: string;
  runtime: number;
  rating: number;
  budget: number;
  poster?: string;
  backdrop: string;
  revenue: number;
  views: number;
  popularity: number;
  seasons_count: number;
  release_date: string;
  year: number;
  genres: Genre[];
  keywords: Keyword[];
  production_countries: ProductionCountry[];
  videos: Video[];
  all_videos?: Video[];
  primary_video: Lien;
  primary_video_count?: number;
  certification?: string;
  images: TitleImage[];
  season?: Season;
  seasons?: Season[];
  reviews?: Review[];
  language: string;
  updated_at?: string;
}
